import React__default from 'react';
import RefIcon from '../../../@ant-design/icons/es/icons/CloseCircleFilled.js';
const getAllowClear = allowClear => {
  let mergedAllowClear;
  if (typeof allowClear === 'object' && (allowClear === null || allowClear === void 0 ? void 0 : allowClear.clearIcon)) {
    mergedAllowClear = allowClear;
  } else if (allowClear) {
    mergedAllowClear = {
      clearIcon: /*#__PURE__*/React__default.createElement(RefIcon, null)
    };
  }
  return mergedAllowClear;
};
var getAllowClear$1 = getAllowClear;
export { getAllowClear$1 as default };
//# sourceMappingURL=getAllowClear.js.map
